import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import App from './App'
import { isDesktop } from '@/lib/platform'
import { signalSwUpdate } from '@/lib/sw-update-signal'
import './index.css'

// Register PWA service worker (skip on desktop - updates handled by Electron)
if ('serviceWorker' in navigator && !isDesktop()) {
  import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({
      onNeedRefresh() {
        signalSwUpdate()
      },
      onOfflineReady() {
        console.info('[SW] Offline ready')
      },
    })
  }).catch(() => {
    // SW registration not critical
  })

  // Force SW update check on every page load - bypasses Cloudflare edge cache
  navigator.serviceWorker.ready.then((reg) => {
    void reg.update()
  })
}

const Router = isDesktop() ? HashRouter : BrowserRouter

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
)
